import { render, staticRenderFns } from "./lb-table.vue?vue&type=template&id=27b32cd0&scoped=true"
import script from "./lb-table.vue?vue&type=script&lang=js"
export * from "./lb-table.vue?vue&type=script&lang=js"
import style0 from "./lb-table.vue?vue&type=style&index=0&id=27b32cd0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b32cd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27b32cd0')) {
      api.createRecord('27b32cd0', component.options)
    } else {
      api.reload('27b32cd0', component.options)
    }
    module.hot.accept("./lb-table.vue?vue&type=template&id=27b32cd0&scoped=true", function () {
      api.rerender('27b32cd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchase/components/lb-table/lb-table.vue"
export default component.exports